const TemplateIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5_5789)">
        <path
          d="M20.4 0.675049H3.6C1.9875 0.675049 0.637497 1.98755 0.637497 3.63755V20.4375C0.637497 22.05 1.95 23.3625 3.6 23.3625H20.4C22.0125 23.3625 23.325 22.05 23.325 20.4375V3.60005C23.325 1.98755 22.0125 0.675049 20.4 0.675049ZM21.675 3.60005V11.1375H12.825V2.32505H20.4C21.075 2.32505 21.675 2.92505 21.675 3.60005ZM3.6 2.32505H11.1375V11.1375H2.325V3.60005C2.325 2.92505 2.925 2.32505 3.6 2.32505ZM2.325 20.4V12.825H11.1375V21.6376H3.6C2.925 21.675 2.325 21.0751 2.325 20.4ZM20.4 21.675H12.825V12.825H21.6375V20.4C21.675 21.0751 21.075 21.675 20.4 21.675Z"
          fill="#111928"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_5789">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TemplateIcon;
